// extracted by mini-css-extract-plugin
export default {"component":"Message_component__OXp7l","header":"Message_header__KB1hR","detail":"Message_detail__bkfnt","value":"Message_value__20qRd","warn":"Message_warn__RcrHM"};